import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasFormKeyDirective } from './gas-form-key.directive';

const DIRECTIVES = [
  GasFormKeyDirective,
];

@NgModule({
  declarations: [
    DIRECTIVES,
  ],
  exports: [
    DIRECTIVES,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasFormKeyModule { }
